import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import {
// 	GetSiteIdMixin
// } from '@/mixins/GetSiteIdMixin'
import Vue from 'vue';
import VueAMap from 'vue-amap'; //注意不要和 AMap原始名称覆盖

import { querySiteBySt, getReplay } from '@/api/api';
import imgUrl from '@/assets/others/index/bg.gif';
import monthSelect from '@/components/date/monthSelect';
import moment from 'moment';
Vue.use(VueAMap); // 初始化vue-amap

VueAMap.initAMapApiLoader({
  // 高德的key
  key: '44641f38739649861c9d7d31f69b4ac2',
  // 插件集合
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.Geolocation'],
  v: '1.4.4'
});
var amapManager = new VueAMap.AMapManager();
var interval;
export default {
  name: 'DataReplay',
  components: {
    monthSelect: monthSelect
  },
  // mixins: [GetSiteIdMixin],
  data: function data() {
    return {
      showLoading: false,
      current: 0,
      date: '',
      // date: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
      selectTag: 0,
      mapStyle: 'amap://styles/dark',
      //设置地图样式
      zoom: 12,
      center: [118.047928, 24.613341],
      plugin: [{
        pName: 'MapType',
        defaultType: 0,
        showRoad: false,
        showButton: false,
        showTraffic: false,
        events: {
          init: function init(o) {}
        }
      }],
      amapManager: amapManager,
      markerList: [],
      st: '32',
      stime: '',
      etime: '',
      tagList: [{
        'name': '小时数据',
        'id': 0
      } // ,{
      // 	'name':'日数据',
      // 	'id':1
      // },{
      // 	'name':'月数据',
      // 	'id':2
      // },
      ],
      result: [],
      moment: moment
    };
  },
  created: function created() {
    this.center = window.localStorage.getItem('mapCenter') && window.localStorage.getItem('mapCenter') != 'null' ? window.localStorage.getItem('mapCenter').split(',') : [118.047928, 24.613341];
    this.zoom = window.localStorage.getItem('mapZoom') ? window.localStorage.getItem('mapZoom') : 12;
    clearInterval(interval);
    this.stime = moment().format('YYYY-MM-DD');
    this.etime = moment().format('YYYY-MM-DD'); // this.getSite()
  },
  destroyed: function destroyed() {
    clearInterval(interval);
  },
  methods: {
    getData: function getData() {
      var _this = this;

      getReplay({
        stime: this.stime,
        etime: this.etime,
        st: this.st
      }).then(function (res) {
        // 数据初始化
        _this.showLoading = false;
        _this.markerList = [];
        _this.result = [];
        clearInterval(interval);

        if (res.success && res.result.length > 0) {
          res.result.forEach(function (item, index) {
            item.forEach(function (item1, index1) {
              if (item1.latitude != 'NaN') item1.position = [item1.attrs.siteMode.longitude, item1.attrs.siteMode.latitude];else item1.position = _this.center;

              switch (item1.attrs.upStandard) {
                case true:
                  item1.color = 'green';
                  break;

                case false:
                  item1.color = 'red';
                  break;

                case null:
                  item1.color = '#ccc';
                  break;
              }
            });
          });
          _this.result = res;
          _this.markerList = res.result[0];
          _this.date = res.result[0][0].dataTime;
          _this.current = 0;
          document.getElementById('site').scrollLeft = 0; // this.intervalFuc(res)
          //加弹窗

          interval = setInterval(function () {
            // setTimeout(()=>{
            _this.intervalFuc(res);
          }, 2000);
        } else if (res.result.length <= 0) {
          _this.$message.warn('暂无数据');
        }
      });
    },
    intervalFuc: function intervalFuc(res) {
      if (this.current > 14) {
        // if(this.current%20==0){
        document.getElementById('site').scrollLeft = 1600 * parseInt(this.current / 16); // }
      }

      if (this.current === res.result.length - 1) {
        document.getElementById('site').scrollLeft = 0;
        this.current = 0; // this.markerList = res.result[this.current + 1]
      } else {
        this.current++;
      }

      this.date = res.result[this.current][0].dataTime;
      this.markerList = res.result[this.current];
    },
    monthChange: function monthChange(e) {},
    searchQuery: function searchQuery() {
      if (this.st == '') {
        this.$message.error('请选择站点类型');
        return;
      }

      clearInterval(interval); // setTimeout(()=>{

      this.showLoading = true;
      this.getData(); // },1000)
    },
    onDateChange: function onDateChange(value, dateString) {
      this.stime = dateString[0];
      this.etime = dateString[1];
    },
    onTotag: function onTotag(id) {
      this.selectTag = id;
    },
    typeChange: function typeChange(val) {
      this.st = val; // this.resetSetItem('treeSt', this.st)
      // this.loadTree(this.value, val)
    }
  }
};